import { Button, Typography, Dialog, DialogContent, DialogActions, DialogTitle } from '@mui/material';
import { ScheduleCreateContext, ScheduleCreateValues } from '../../contexts/ScheduleCreateContext';
import { useContext } from 'react';
import { CloseDialogAction } from '../../../../components/shared/dialogs/CloseDialogAction';

const ScheduleCreateDeleteCategoryModal = () => {
  const { t,
    isScheduleDeleteModalOpen,
    handleClose,
    confirmDeleteSchedule } = useContext(ScheduleCreateContext) as ScheduleCreateValues;

  return (
    <Dialog open={isScheduleDeleteModalOpen}
      onClose={handleClose}
      maxWidth='sm'
      fullWidth>
      <DialogTitle>
        {t('deleteSchedule')}
        <CloseDialogAction onCancel={handleClose} />
      </DialogTitle>
      <DialogContent>
        <Typography>{t('approvalDialogScheduleMessage')}</Typography>
      </DialogContent>
      <DialogActions >
        <Button
          variant="secondary"
          size='lg'
          onClick={handleClose}>{t('cancel')}</Button>
        <Button variant="bad"
          size='lg'
          onClick={confirmDeleteSchedule}>
          {t('confirm')}
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default ScheduleCreateDeleteCategoryModal;